const BlankPage = () => {
  return <></>
}

export default BlankPage
